import React from 'react';
import BilingualField from '../../../components/common/BilingualField';

export default function ContactFooterEditor({ content, handleBilingualChange }) {
  return (
    <div className="dash-card mb-4" style={{ maxWidth: 900 }}>
      <h3 className="dash-card-title mb-4">Contact Info Section</h3>

      <BilingualField
        label="Overline"
        fieldName="contactOverline"
        value={content.contactOverline}
        onChange={handleBilingualChange}
        placeholder="Contact Info"
      />

      <div className="form-row-2">
        <BilingualField
          label="Title (Regular Text)"
          fieldName="contactTitleRegular"
          value={content.contactTitleRegular}
          onChange={handleBilingualChange}
          placeholder="Let's get you "
        />
        <BilingualField
          label="Title (Italic Text)"
          fieldName="contactTitleItalic"
          value={content.contactTitleItalic}
          onChange={handleBilingualChange}
          placeholder="dancing"
        />
      </div>

      <div className="form-row-2">
        <BilingualField
          label="Location"
          fieldName="contactLocation"
          value={content.contactLocation}
          onChange={handleBilingualChange}
          placeholder="Hong Kong · Multiple Locations"
        />
        <BilingualField
          label="Phone / WhatsApp"
          fieldName="contactPhone"
          value={content.contactPhone}
          onChange={handleBilingualChange}
          placeholder="+852 6681 5305"
        />
      </div>

      <div className="form-row-2">
        <BilingualField
          label="Email Address"
          fieldName="contactEmail"
          value={content.contactEmail}
          onChange={handleBilingualChange}
          placeholder="info@etsacademy.com"
        />
        <BilingualField
          label="Operating Hours"
          fieldName="contactHours"
          value={content.contactHours}
          onChange={handleBilingualChange}
          placeholder="Mon–Sat: 7am–9pm · Sun: 9am–6pm"
        />
      </div>

      <hr style={{ margin: '32px 0', border: 'none', borderTop: '1px solid var(--border)' }} />

      <h3 className="dash-card-title mb-4">Footer Section</h3>
      <BilingualField
        label="Footer Tagline"
        fieldName="footerTagline"
        value={content.footerTagline}
        onChange={handleBilingualChange}
        isTextarea
        rows={3}
        placeholder="The complete dance academy management platform. Move, grow, and perform your best with Every Talent Shines Academy."
      />
    </div>
  );
}
